import React from 'react';
import { Input, Form, Label, FormGroup } from 'reactstrap';
import { auth } from '../../Api';
import { emailProblem } from '../../utils/signin';
import SiteLayout from '../../components/site/SiteLayout';
import { LOGIN_PATH, forgotPasswordReply } from '../../utils/forgotPassword';

// Forgot password (/authentication/forgot-password), in the Mobiliis design like the sign-in page (components/site/):
// the email address -> password/sendtoken emails a link to the server's reset page (12 hours), which then leads back to
// the sign-in page. Whether the address has an account is not said (utils/forgotPassword.js).
class ForgotPassword extends React.Component {
	constructor(props) {
		super(props);
		this.state = { email: '', emailTouched: false, busy: false, reply: null };
	}

	send = (event) => {
		event.preventDefault();
		this.setState({ emailTouched: true });
		if (emailProblem(this.state.email) !== null || this.state.busy) {
			return;
		}
		this.setState({ busy: true, reply: null });
		auth.forgotPassword({ email: this.state.email.trim() })
			.then((res) => this.setState({ busy: false, reply: forgotPasswordReply(res && res.data, this.state.email.trim()) }))
			.catch(() => this.setState({ busy: false, reply: forgotPasswordReply(null, this.state.email.trim()) }));
	};

	render() {
		const { email, emailTouched, busy, reply } = this.state;
		const problem = emailTouched ? emailProblem(email) : null;
		return (
			<SiteLayout page="login">
				<div className="mob-narrow">
					<h1 className="mob-title">Forgot your password?</h1>
					<p className="mob-lede">Enter the email address you sign in with. We will email you a link to choose a new password.</p>
					{reply && reply.sent ? (
						<div className="mob-card">
							<div className="mob-message mob-message-success" role="status">{reply.text}</div>
							<a href={LOGIN_PATH} className="mob-btn mob-btn-primary mob-btn-block mt-3">Back to sign in</a>
						</div>
					) : (
						<Form className="mob-card" noValidate onSubmit={this.send}>
							{reply && <div className="mob-message mob-message-error" role="alert">{reply.text}</div>}
							<FormGroup>
								<Label for="email">Email</Label>
								<Input type="email" id="email" name="email" value={email} autoComplete="username" placeholder="Email"
									onChange={(event) => this.setState({ email: event.target.value, emailTouched: true, reply: null })} />
								{problem && <div className="error mt-1"><span className="error">{problem}</span></div>}
							</FormGroup>
							<button type="submit" className="mob-btn mob-btn-primary mob-btn-block mt-3" disabled={busy || emailProblem(email) !== null}>
								{busy ? 'Sending...' : 'Send me a link'}
							</button>
							<p className="text-center mt-3 mb-0"><a href={LOGIN_PATH}>Back to sign in</a></p>
						</Form>
					)}
				</div>
			</SiteLayout>
		);
	}
}

export default ForgotPassword;
